import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const CurrentSDMLoansTable = ({ data, onChange }) => {
  const rows = data || [];

  const handleCellChange = (rowIndex, field, value) => {
    const updatedRows = rows.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, [field]: value };
      }
      return row;
    });
    onChange(updatedRows);
  };

  const handleAddRow = () => {
    const newRow = {
      title: "",
      limit: 0,
      currency: "",
      currentDebt: 0,
      interest: 0,
      contractDate: "",
      expirationDate: "",
      guarantorDescription: "",
      deposit: 0
    };
    onChange([...rows, newRow]);
  };

  const handleDeleteRow = (rowIndex) => {
    const updatedRows = rows.filter((_, index) => index !== rowIndex);
    onChange(updatedRows);
  };

  const columns = [
    { label: "Заемщик, № договора, кредитный продукт", minWidth: 200 },
    { label: "Сумма действующего лимита", minWidth: 120 },
    { label: "Валюта", minWidth: 80 },
    { label: "Текущая сумма задолженности", minWidth: 120 },
    { label: "%", minWidth: 60 },
    { label: "Дата договора", minWidth: 130 },
    { label: "Дата окончания, график погашения", minWidth: 200 },
    { label: "Вид и стоимость залога, кто является поручителем, дата последней проверки", minWidth: 250 },
    { label: "Сумма залога, руб.", minWidth: 120 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          СДМ-БАНК. ДЕЙСТВУЮЩИЕ КРЕДИТЫ (от большего к меньшему)
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
            <TableRow sx={sdmTableStyles.headerRow}>
              {columns.map((headCell, index) => (
                <TableCell
                  key={index}
                  sx={getHeaderCellStyle(headCell.minWidth)}
                >
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell sx={sdmTableStyles.emptyCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.title || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'title', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    type="number"
                    value={row.limit || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'limit', e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.numberField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.currency || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'currency', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    type="number"
                    value={row.currentDebt || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'currentDebt', e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.numberField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.interest || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'interest', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.contractDate || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'contractDate', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.expirationDate || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'expirationDate', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.guarantorDescription || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'guarantorDescription', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    type="number"
                    value={row.deposit || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'deposit', e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.numberField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteRow(rowIndex)}
                    sx={sdmTableStyles.deleteButton}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={10} sx={sdmTableStyles.addRowCell}>
                <Button
                  fullWidth
                  onClick={handleAddRow}
                  startIcon={<AddCircleIcon />}
                  sx={sdmTableStyles.addRowButton}
                >
                  Добавить строку
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CurrentSDMLoansTable;
